import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { CTALink, IconButton } from "../../ui/CTA";
import { EditIcon, MemberIcon } from "../../ui/Icon/HmIcons";
import Image from "../../ui/Image";
import BodyText from "../../ui/Typography/texts/BodyText";
import { BodyTextProps } from "../../ui/Typography/texts/BodyText/types";
import HeadingProps from "../../ui/Typography/titles/Heading/types";
import HeadingLarge from "../../ui/Typography/titles/HeadingLarge";
import HeadingSmall from "../../ui/Typography/titles/HeadingSmall";
import ProfileHeaderLoader from './components/ProfileHeaderLoader';
import styles from './ProfileHeader.module.scss';
const ProfileHeader = ({ isEditable, onProfileImageClick, userName, figcaptionClassName, imageSrc, editAltText, imageAltText, shouldRenderUsername = true, fetchProfileFailed = false, isLoading = false, tag = 'h2', href, headingSize = 'small', shouldBeResponsive = true, }) => {
    const iconAltText = isEditable ? editAltText : userName;
    const profileImageAltText = isEditable ? editAltText : imageAltText;
    const UsernameTemplate = ({ children }) => {
        if (href) {
            return (React.createElement(CTALink, { ctaLink: true, size: "large", to: href, href: href }, children));
        }
        if (!href) {
            if (tag === 'p')
                return React.createElement(BodyText, { preamble: true }, children);
            if (headingSize === 'large')
                return React.createElement(HeadingLarge, { Tag: tag }, children);
            if (headingSize === 'small')
                return React.createElement(HeadingSmall, { Tag: tag }, children);
        }
        return null;
    };
    const ImageWrapper = ({ children }) => isEditable ? (React.createElement("button", { type: "button", className: cn(styles.invisibleButton), onClick: onProfileImageClick }, children)) : href ? (React.createElement(Link, { to: href }, children)) : (children);
    return (React.createElement("figure", { className: styles.wrapper },
        isLoading ? (React.createElement(ProfileHeaderLoader, { shouldRenderUsername: shouldRenderUsername })) : fetchProfileFailed ? (React.createElement("div", { className: styles.placeholderCircle })) : imageSrc ? (React.createElement(ImageWrapper, null,
            React.createElement(Image, { className: cn(styles.pictureContainer, styles.roundedImage, !shouldBeResponsive && styles.nonResponsive), url: imageSrc, altText: profileImageAltText, shouldLazyLoad: false, shouldShowSkeleton: false }))) : (React.createElement(IconButton, { onClick: onProfileImageClick, className: cn(styles.pictureContainer, styles.dashedBorder, !shouldBeResponsive && styles.nonResponsive), iconElement: isEditable ? React.createElement(EditIcon, { size: "normal" }) : React.createElement(MemberIcon, { size: "large" }) }, iconAltText)),
        shouldRenderUsername && !isLoading && (React.createElement("figcaption", { className: cn(figcaptionClassName, fetchProfileFailed && styles.hiddenUsername) },
            React.createElement(UsernameTemplate, null, userName)))));
};
export default ProfileHeader;
//# sourceMappingURL=ProfileHeader.js.map